import { isNil } from 'lodash';

export function callAllFunctions(...functions: any[]): (parms?: any) => void {
    return function merged() {
        for (const fn of functions) {
            if (isNil(fn)) {
                continue;
            }
            if (typeof fn === 'function') {
                fn.apply(null, arguments);
                continue;
            }
        }
    };
}
